import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {fetchPosts, fetchPostDetail} from "../../api/redux/post";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import styled from "styled-components";
import {Link} from "react-router-dom";
import Button from "../../components/Button";
import {Img} from "../../components/Img";
import Title from "../../components/Title";
import InnerBanner from "../../components/InnerBanner";
import {Loading} from "../../components/Loading";
import HomeBanner from "../../components/home/HomeBanner";
import Newsletter from "../../components/takatalks/Newsletter";
import FeaturedProjects from "../../components/home/FeaturedProjects";
import Map from "../../components/Map";
import Overview from "../../components/home/Overview";
import WhyUs from "../../components/home/WhyUs";
import ContactCta from "../../components/home/ContactCta";
import Testimonial from "../../components/home/Testimonial";
import {fetchHome} from "../../api/redux/home";
import TopPicks from "../../components/home/TopPicks";
import SliderAnimation from "../../components/SliderAnimation";

const Home = ({scrollContainerRef}) => {

    const dispatch = useDispatch()

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.HOME
        dispatch(fetchHome([api_url]))
    }, [])

    let getPost = useSelector(state => state.home)

    let banner=getPost?.posts?.page_data?.banner;
    let about=getPost?.posts?.page_data?.about;
    let why=getPost?.posts?.page_data?.why_us;
    let featured=getPost?.posts?.projects?.filter(element=>element?.isfeatured==='on').slice(0, 4);
    let map=getPost?.posts?.page_data?.map;
    let cta=getPost?.posts?.page_data?.cta;
    let testimonial=getPost?.posts?.page_data?.testimonial;

    return (
        <StyledSection>
            <HomeBanner data={banner} scrollContainerRef={scrollContainerRef}/>
            <TopPicks data={about}/>
            {/*<Overview data={about}/>*/}
            <WhyUs data={why}/>
            {/*<SliderAnimation data={why}/>*/}
            <FeaturedProjects data={featured}/>
            <ContactCta
                imgSrc={cta?.image}
                subTitle={cta?.title}
                desc={cta?.desc}
                btntxt={'Learn More'}
                btnColor={'#323232'}
                btnBg={'#E8E8E8'}
            />
            <Testimonial data={testimonial}/>
            <Map data={map}/>
        </StyledSection>
    );
};

const StyledSection = styled.section`

`;


export default Home;
